import { ProductImportPage } from "@/features/product/pages/ProductImportPage";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const IMPORT_PERMISSION = {
	consignment: "product_item.create_consignment",
	"non-consignment": "product_item.create_non_consignment",
} as const;

export const Route = createFileRoute("/admin/product/import")({
	validateSearch: z.object({
		type: z.enum(["consignment", "non-consignment"]),
	}),
	beforeLoad({ context, search }) {
		if (
			!context.authAdapter.can({
				permissions: [IMPORT_PERMISSION[search.type]],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	const { type } = Route.useSearch();
	return <ProductImportPage importType={type} />;
}
